import { render, staticRenderFns } from "./ComponentAverage.vue?vue&type=template&id=17b2db3c&scoped=true&"
import script from "./ComponentAverage.vue?vue&type=script&lang=js&"
export * from "./ComponentAverage.vue?vue&type=script&lang=js&"
import style0 from "./ComponentAverage.vue?vue&type=style&index=0&id=17b2db3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b2db3c",
  null
  
)

export default component.exports